export default __webpack_public_path__ + "static/media/closeButton.feb89873.svg";